export const PAGINATION_LIMIT = 20;
export const DEFAULT_CURRENT_PAGE = 1;
